import React from 'react';
import BlockIcon from '@mui/icons-material/Block';
import { useTranslation } from 'react-i18next';
const AccessDenied= () => {
    const { t } = useTranslation();
    return (
        <div className='h-screen w-screen'>
            <div className="flex flex-col items-center justify-center h-[260px] w-[480px] py-auto px-10 mx-auto mt-[24vh] rounded-lg bg-gray-100">
                <BlockIcon className="text-red-600 mb-4" sx={{fontSize:62}} />
                <h1 className=" font-bold text-3xl mb-2">{t("labels.access-denied")}</h1>
                <p className="mt-4 text-xl text-gray-700">{t("labels.access-denied-message")}</p>
                
            </div>
        </div>
    );
};

export default AccessDenied;